// extracted by mini-css-extract-plugin
export default {"TextError":"FKp6_","TextErrorMessage":"B8teB"};